import { TitreFiltresModeles } from '@components/titre-filtres-modeles/models';
import { Block } from '@shared/models';

export const titreFiltresModelesMock = (showOrderingFilter: boolean = false): Block<TitreFiltresModeles> => ({
  type: 'titre-filtres-modeles',
  data: {
    title: {
      text: `Ici on ne manque pas d'inspi' [[pour votre cuisine]]`,
      as: 'h1',
    },
    budget: '2000-4000;4000-6000;6000',
    showOrderingFilter,
    gtmConfig: {
      event: 'click_cta_filtres',
      group: 'filtres',
      description: 'listing cuisines',
      context: 'utilisation de filtre',
    },
  },
});

export const titresFiltresModelesFlexibleMock = (data: TitreFiltresModeles) => ({
  type: 'titre-filtres-modeles',
  data,
});
